<template>
    <f7-page no-toolbar>
        <f7-navbar title="错误" back-link="返回"></f7-navbar>
        <f7-block class="text-center">
            <div><i class="icon-jmui icon-jmui-error"></i></div>
            <div>{{msg}}</div>
        </f7-block>
    </f7-page>
</template>

<script type="text/ecmascript-6">
  export default {
    data () {
      return {
        msg: '无效的访问页面'
      }
    },
    created () {
      if (this.$f7route.query && this.$f7route.query.message) {
        this.msg = this.$f7route.query.message
      }
    },
    methods: {},
    mounted () {
    }
  }
</script>
<style lang="scss" scoped type="text/css">
</style>
